import {Selectors} from '../Settings';
import TrialTrainingForm from '../Modules/TrialTrainingForm';

class TeamController {
    constructor() {
        this.initializeModules();
    }

    initializeModules() {
        this.initializeModule(Selectors.trialTrainingForm, TrialTrainingForm);
    }

    initializeModule(elementSelector, moduleClass) {
        let $element = $(elementSelector);
        if ($element.length > 0) {
            new moduleClass($element);
        }
    }
}

export default TeamController;